module.exports = __webpack_public_path__ + "static/media/Lunch_med_Curoflow_for_digitala_vardtjanster.4a00f914.webp";